<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <div *ngIf="!loading">
            <app-referring-physician-view-component *ngIf="referringPhysicianView" [referringPhysicianView]="referringPhysicianView"></app-referring-physician-view-component>
        </div>
    </div>
</div>